
import { useState } from "react";
import axios from "axios";
import config from "../../../Helpers/config.json";
import { errorMessages } from "../../../Helpers/ErrorMessages";
import { history } from "../../../Helpers/history";
import { useReusableNewWholeSales } from "./useReusableNewWholeSales";
import { useAddProvider } from "../../Customer/CustomHooks/useAddProvider";
import { convertDate, validateCurrentDate } from "../../../Utils/ConvertDate";

export const useCreateWholeSaleInvoice = (actions, invoice_number = '', saletype = '') => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    const singleUser = !user ? {} : user;
    const user_id = !singleUser.user_id ? 1 : singleUser.user_id;

    const [submitted, setSubmitted] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [invoice_id, setInvoiceId] = useState('');
    const [isSubmitted, setIsSubmitted] = useState('idle');
    const [provider, setProvider] = useState('');
    const [providerDetails, setProviderDetails] = useState({ account_name: '', card_number: '' });
    const [isCardNumber, setIsCardNumber] = useState(false);
    const [invoice_customer_id, setInvoiceCustomerId] = useState('');
    const [receiptData, setReceiptData] = useState({ products: [], customer: {}, loading: 'idle' });

    const { stateFunctions, stateVariables } = useReusableNewWholeSales(actions, invoice_number, false, saletype);
    const { providerProps } = useAddProvider(actions);

    const { customer, rows, totals, initialState, customerDetails, state } = stateVariables;
    const { setRows, setCustomer, setTotals, setCustomerDetails, setIsBlocking, setState } = stateFunctions;

    const permissions = !singleUser.permission ? {} : singleUser.permission;
    // const approval_status = permissions.approval_status || {};
    // const managependingsale = permissions.managependingsale || {};

    /** Handlers for provider inputs */
    const handleChangeIsCard = (event) => setIsCardNumber(event.target.checked);
    const handleChangeProvider = (event) => setProvider(event.target.value);
    const handleChangeProviderDetails = (event) => {
        const { name, value } = event.target;
        setProviderDetails({ ...providerDetails, [name]: value });
    };
    const handleCloseDialog = () => setOpenDialog(false);

    /** Retrieve invoice details for preview */
    const retrieveInvoiceDetails = (item) => {
        const { invoice_number: inv_number, customer_id: cus_id } = item;
        if (!inv_number || !cus_id) return;

        const formData = new FormData();
        formData.append('receipt_number', '');
        formData.append('invoice_number', inv_number);
        formData.append('customer_id', cus_id);

        setReceiptData({ ...receiptData, loading: 'loading' });

        axios.post(`${config.epharmUrl}/Cinvoice/view_receipt`, formData)
            .then(response => {
                const dataRes = response.data ?? {};
                const arr = dataRes.bill ?? [];
                const customer_details = dataRes.customer_details ?? {};
                const obj = arr[0] ?? {};
                setReceiptData({ ...receiptData, products: arr, customer: { ...customer_details, ...obj }, loading: 'success' });
                setOpenDialog(true);
            })
            .catch(error => {
                console.error("Error fetching invoice for preview:", error);
                setReceiptData({ ...receiptData, loading: 'error' });
            });
    };

    /** Save wholesale invoice */
    const handleSaveInvoice = (event) => {
        event.preventDefault();

        const { account_name, card_number } = providerDetails;
        const { n_total, grand_total_price } = totals;
        const { credit_limit } = customerDetails;
        const { customer_id } = customer;
        const { invoice_date } = state;

        const insuranceRequired = isCardNumber && account_name && card_number;
        const organizationRequired = !isCardNumber && account_name;
        const allRowsValid = rows.length > 0 && rows.every(item => item.batch_id && item.product_name && item.product_quantity);

        setSubmitted(true);
        const requiredLimit = (credit_limit > 0 && credit_limit >= n_total) || credit_limit === 0;
        const validate_invoice_date = validateCurrentDate(invoice_date);

        if (allRowsValid &&  customer_id  && requiredLimit ) {
            setIsSubmitted('pending');
            setIsBlocking(false);

            const data = rows.map((row) => ({
                ...row,
                // ...row.batch_id,
                product_id: row?.product_id,
                quantity: +row?.product_quantity,
                rate: +row?.product_rate,
                id: row?.related_product,
                discount: row?.discount ?? 0,
                discount_rate: row?.discount_rate ?? 0,
                discount_amount: row?.discount_amount ?? 0,
                batch_details_id: row?.batch_details_id ?? null,
            }));

            axios.post(
                `${config.epharmUrl}/Cinvoice/insert_invoice`,
                {
                    payment_type: 2,
                    customer_id,
                    total_amount: +grand_total_price,
                    bill_details: data,
                    invoice_date,
                    is_wholesale: true,
                },
                { headers: { user_id } }
            ).then(response => {
                const data = response.data ?? {};
                const dt = data.data ? data.data : {};
                const recep = dt[0]?.receipt ?? '';
                const inv_id = recep.invoice_no ?? '';
                const cus_id = dt[0]?.customer_id ?? '';

                retrieveInvoiceDetails({ invoice_number: inv_id, customer_id: cus_id });
                actions.snackbarActions.successSnackbar("Invoice saved successfully!");

                setIsSubmitted('resolved');
                setSubmitted(false);
                setRows(initialState);
                setCustomer({ customer_name: '', customer_id: '' });
                setTotals({
                    grand_total_price: 0,
                    n_total: 0,
                    change: 0,
                    due_amount: 0,
                    paid_amount: '',
                    previous_amount: 0,
                    total_discount_amount: 0
                });
                setCustomerDetails({ credit_limit: 0 });
                setInvoiceId(inv_id);
                setInvoiceCustomerId(cus_id);
            }).catch(error => {
                errorMessages(error, null, actions);
                setIsSubmitted('rejected');
            });
        }
    };

    const validateInvoice = ({ rows, customer_id, invoice_date, totals }) => {

        for (let idx = 0; idx < rows.length; idx++) {
          const item = rows[idx];
      
          if (!item.product_name || !item.batch_id || !item.product_quantity) {
            // actions.snackbarActions.errorSnackbar(`Row ${idx + 1} is incomplete.`);
            return { valid: false,message:`Row ${idx + 1} is incomplete.`};
          }
      
          if (item.isPriceLower) {
            // actions.snackbarActions.errorSnackbar(`Row ${idx + 1}: price cannot be lower than original.`);
            return { valid:false,message:`Row ${idx + 1}: for product ${item.product_name} So the price cannot be lower than original Price.`};
          }
          if (item.isError ) {
            // actions.snackbarActions.errorSnackbar(`Row ${idx + 1}: price cannot be lower than original.`);
            return { valid:false,message:`Row ${idx + 1}: for product ${item.product_name} So the Quantity cannot be lower .`};
          }  
          if (item.isDiscountable) {
            // actions.snackbarActions.errorSnackbar(`Row ${idx + 1}: discount cannot exceed rate.`);
            return { valid:false,message:`Row ${idx + 1}: for product ${item.product_name} So the discount cannot exceed rate.`};
          }
        }
        // Validate rows
        const allRowsValid = rows.every(
          item => item.batch_id && item.product_name && item.product_quantity 
        );
        if (!allRowsValid) {
          return { valid: false, message: "Please ensure all products have batch, name, quantity and valid discount" };
        }
      
        // Validate customer
        if (!customer_id) {
          return { valid: false, message: "Please select a customer before submitting" };
        }
      
        // Validate invoice date
        if (!invoice_date) {
          return { valid: false, message: "Please select a valid  Date" };
        }
      
        // Optionally: check totals
        if (totals.grand_total_price <= 0) {
          return { valid: false, message: "Total amount should be greater than zero" };
        }
      
        return { valid: true };
      };
      

    /** Save dispensary invoice */
    const saveDispensarInvoice = (event) => {
        event.preventDefault();

        const { account_name, card_number } = providerDetails;
        const { n_total, grand_total_price } = totals;
        const { credit_limit } = customerDetails;
        const { customer_id } = customer;
        const { invoice_date } = state;

        // const insuranceRequired = isCardNumber && account_name && card_number;
        // const organizationRequired = !isCardNumber && account_name;
        const allRowsValid = rows.length > 0 && rows.every(item => item.batch_id && item.product_name && item.product_quantity);

        setSubmitted(true);

        const requiredLimit = (credit_limit > 0 && credit_limit >= n_total) || credit_limit === 0;
        const validation = validateInvoice({ rows, customer_id, invoice_date: state.invoice_date, totals });

        if (!validation.valid) {
            actions.snackbarActions.infoSnackbar({ message: validation.message, duration: 5000 });
            setSubmitted(false);
            return;
        }
        // const validate_invoice_date = validateCurrentDate(invoice_date);

        if (allRowsValid   && requiredLimit && customer_id) {
            setIsSubmitted('pending');
            setIsBlocking(false);

            const data = rows.map((row) => ({
                product_id: row.product_id,
                batch_id: typeof row.batch_id === "object" ? row.batch_id.batch_id : row.batch_id,
                purchase_detail_id: typeof row.batch_id === "object" ? row.batch_id.purchase_detail_id : null,
                quantity: +row.product_quantity,
                rate: +row.product_rate,
                discount: row.discount ?? 0,
                discount_rate: row.discount_rate ?? 0,
                discount_amount: row.discount_amount ?? 0,
                total_price: row.total_price ?? (+row.product_quantity * +row.product_rate),
                batch_details_id: row.batch_details_id ?? null,
            }));

            axios.post(
                `${config.epharmUrl}/Cinvoice/create/dispensar/invoice`,
                {
                    payment_type: 2,
                    customer_id,
                    total_amount: +grand_total_price,
                    bill_details: data,
                    invoice_date,
                    is_wholesale: saletype === "wholesale",
                },
                { headers: { user_id } }
            ).then(response => {
                const res = response.data ?? {};
                const dt = Array.isArray(res.data) ? res.data[0] : res.data ?? {};
                const inv_id = dt.invoice_no ?? '';
                const cus_id = dt.customer_id ?? customer_id;

                if (inv_id && cus_id) {
                    retrieveInvoiceDetails({ invoice_number: inv_id, customer_id: cus_id });
                    setInvoiceId(inv_id);
                    setInvoiceCustomerId(cus_id);
                }

                actions.snackbarActions.successSnackbar("Dispensar Invoice saved successfully!");

                setIsSubmitted('resolved');
                setSubmitted(false);
                setRows(initialState);
                setCustomer({ customer_name: "", customer_id: "" });
                setProviderDetails({ account_name: "", card_number: "" });
                setTotals({
                    grand_total_price: 0,
                    n_total: 0,
                    change: 0,
                    due_amount: 0,
                    paid_amount: "",
                    previous_amount: 0,
                    total_discount_amount: 0,
                });
                if (setState) {
                    setState({ ...state, invoice_date: convertDate(), inva_details: "" });
                }
                setCustomerDetails({ credit_limit: 0 });
            }).catch(error => {
                console.error("Invoice creation error:", error);
                errorMessages(error, null, actions);
                setIsSubmitted('rejected');
                setSubmitted(false);
            });
        } else {
            actions.snackbarActions.infoSnackbar({
                message: "Please check all required fields and product entries",
                duration: 5000,
            });
            setSubmitted(false);
        }
    };

    /** Handle pending sales save for cashier */
    const handleCashierSaveInvoice = (event) => {
        if (event) event.preventDefault();
        setSubmitted(true);

        const { paid_amount, n_total, change } = totals;
        const { customer_id } = customer;
        const { invoice_date } = state;

        const allRowsValid = rows.every(item => item.batch_id && item.product_name && item.product_quantity);
        const validate_invoice_date = validateCurrentDate(invoice_date);

        if (!allRowsValid) {
            actions.snackbarActions.infoSnackbar({
                message: "Please ensure all products have batch, name, quantity",
                duration: 5000,
            });
            setSubmitted(false);
            return;
        }
        const validation = validateInvoice({ rows, customer_id, invoice_date: state.invoice_date, totals });

        if (!validation.valid) {
            actions.snackbarActions.infoSnackbar({ message: validation.message, duration: 5000 });
            setSubmitted(false);
            return;
        }


        // if (!validate_invoice_date) {
        //     actions.snackbarActions.infoSnackbar({
        //         message: "Please select a valid invoice date",
        //         duration: 5000,
        //     });
        //     setSubmitted(false);
        //     return;
        // }

        if (!customer_id) {
            actions.snackbarActions.infoSnackbar({
                message: "Please select a customer before submitting",
                duration: 5000,
            });
            setSubmitted(false);
            return;
        }

        setIsSubmitted("pending");
        setIsBlocking(false);

        const payload = {
            paid_amount,
            balance: change,
            payment_type: 2,
            bill_details: rows.map((row) => ({
                invoicedetails_id: row?.invoicedetails_id ?? row?.id,
                product_id: row?.product_id,
                quantity: row?.product_quantity,
                rate: row?.product_rate,
                discount: row?.discount ?? 0,
                discount_rate: row?.discount_rate ?? 0,
                discount_amount: row?.discount_amount ?? 0,
                total_price: row?.total_price ?? 0,
                batch_id: row?.batch_id,
                expiry_information: row?.expiry_information ?? null,
                batch_details_id: row?.batch_details_id ?? null,

            })),
            invoice_date,
        };

        axios.post(`${config.epharmUrl}/Cinvoice/cashier/pending-sales/${invoice_number}/save`, payload)
            .then(response => {
                const data = response.data ?? {};
                const recep = data.receipt ?? {};
                const inv_id = recep.invoice_no ?? '';
                const cus_id = recep.customer_id ?? customer_id;

                if (inv_id) retrieveInvoiceDetails({ invoice_number: inv_id, customer_id: cus_id });

                actions.snackbarActions.successSnackbar(`Invoice ${inv_id} saved successfully!`);

                setIsSubmitted("resolved");
                setSubmitted(false);

                // if ((approval_status.read)?.read) {
                //     const audio = new Audio('/audio/happy-bell-alert.mp3');
                //     audio.play();
                // }

                setRows(initialState);
                setTotals({
                    grand_total_price: 0,
                    n_total: 0,
                    change: 0,
                    due_amount: 0,
                    paid_amount: "",
                    previous_amount: 0,
                    total_discount_amount: 0,
                });
                setCustomerDetails({ credit_limit: 0 });
                setInvoiceId(inv_id);
                setInvoiceCustomerId(cus_id);
            })
            .catch(error => {
                errorMessages(error, null, actions);
                setIsSubmitted("rejected");
                setSubmitted(false);
            });
    };

    /** Handlers for snackbar and invoice preview */
    const handleCloseSnackbar = () => actions.snackbarActions.hideSnackBar();
    const handlePreviewInvoice = () => history.push(`/invoice_print/${invoice_customer_id}/${invoice_id}`);
    const handlePreview = () => history.push(`/invoice_print_new/${invoice_customer_id}/${invoice_id}`);

    const isPending = isSubmitted === 'pending';
    const isResolved = isSubmitted === 'resolved';
    const isRejected = isSubmitted === 'rejected';

    return {
        submitted, stateFunctions, stateVariables, openDialog, invoice_id,
        isPending, isResolved, isRejected, providerProps, handleCloseDialog,
        handleSaveInvoice, handleCloseSnackbar, handlePreview, providerDetails,
        handleChangeProviderDetails, handleChangeProvider, provider, isCardNumber,
        handleChangeIsCard, receiptData, saveDispensarInvoice, handleCashierSaveInvoice,
        handlePreviewInvoice,
    };
};
